import { Grid, Paper } from "@material-ui/core";
import styled from 'styled-components';

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
`;

export const FormContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  padding-top: 16px;
  gap: 16px;  
  max-height: 100vh;
  padding: 26px;
  flex-direction: column;

  @media(min-width: 768px) {
    flex-direction: row;
  }
`;

export const CardColumn = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 16px;
`;

export const GroupInfoPaper = styled(Paper)`
  padding: 16px;
  width: 100%;
  display: flex;
  
  flex-direction: column;
`;

export const GroupInfoInputsContainer = styled(Grid)`
  width: 100%;
  margin-top: 16px;

  &:nth-child(1) {
    padding-left: 0px !important;
  }
  
  &:nth-child(2) {
    padding-right: 0px !important;
  }
`;

export const Title = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #031795;
`;

export const SectionTitle = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const ActionButtonsContainer = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    padding: 26px;
    padding-top: 16px;
    justify-content: center;
    align-items: center;
    gap: 12px;
`;
